import { ApexAutomationList } from '../../../general/apex-classes';
import React from 'react';

export interface ApexClassAutomationTabsProps {
	index: number;
	sonarObjectId: number;
}

export const ApexClassAutomationTab: React.FC<ApexClassAutomationTabsProps> = ({ index, sonarObjectId }) => {
	const uri = `v2/salesforce/sfApexClasses/${sonarObjectId}/automations`;

	return (
		<ApexAutomationList
			parentIndex={ index }
			uri={ uri } />
	);
};
